<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid">
    <div class="row">
      <div class="category-head">
        <div class="back-link">
          <a @click="$router.back()">←</a>
        </div>
        <div class="category-title">
          <p>{{ pageTitle }}</p>
        </div>
      </div>
    </div>

    <div class="row d-flex gap-5 ">
      <div class="col-sm-2 card " v-for="category in allCategoryList" :key="category.category_id">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <div class="star">
            <i class="fas fa-star" v-if="! category.following"
               @click="followUnfollowTopic(category.topic_id, true)"></i>
            <i class="fas fa-star " v-if="category.following" style="color: #F6961B"
               @click="followUnfollowTopic(category.topic_id, false)"></i>
          </div>
          <router-link :to="{ path: '/topic-details', query: {
            topic_id: category.topic_id,
            topic: 'Topic',
            category_name: category.category_name
          }
         }" class="d-flex flex-column justify-content-center align-items-center" >
            <img :src="category.image_url" alt="Card image">
            <p class=" ">{{ category.name }} </p>
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";

export default {
  name: "CategoryList",
  components: {
    Loader,
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      categoryType: this.$route.query.type,
      pageTitle: this.$route.query.page_title,
      categoryId: this.$route.query.category_id,
      categoryList: [],
    }
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    getCategoryList() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/topics', {category_id: this.categoryId}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.categoryList = response.data.topics;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    followUnfollowTopic(topic_id, topic_follow) {
      this.loaderActive = true;
      let data = {
        topic_id: topic_id,
        follow: topic_follow
      }
      sendRequest('post', 'v2.0/follow-unfollow-topic', data, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.categoryList = this.categoryList.map(topic => {
                if (topic.topic_id === topic_id) {
                  return {...topic, following: topic_follow};
                }
                return topic;
              });
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
  },
  computed: {
    allCategoryList() {
      return this.categoryList;
    }
  }
}
</script>

<style scoped>

</style>
